export enum PdkType {
    ss = 'ss',
    mr = 'mr',
}
